import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { businessServices } from "../data/services";

const colTitle = "am-eyebrow text-mute";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-surface">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-2 gap-10 px-4 py-14 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div className="col-span-2 lg:col-span-1">
          <Logo />
          <p className="mt-4 text-sm leading-relaxed text-mute">
            Formation, accounting, tax, HR, CFO and family office services across India, the Middle East and
            Africa, backed by a team that has served clients in 60+ countries.
          </p>
        </div>

        <nav aria-label="Business services">
          <p className={colTitle}>For businesses</p>
          <ul className="mt-4 space-y-2.5">
            {businessServices.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} data-testid={`footer-link-${s.slug}`} className="text-sm text-mute transition-colors duration-200 hover:text-ink">
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Family services">
          <p className={colTitle}>For families</p>
          <ul className="mt-4 space-y-2.5">
            {["Private Wealth & Family Office", "Succession planning", "Family governance"].map((label) => (
              <li key={label}>
                <Link
                  to="/services/private-wealth-family-office"
                  data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-$/, "")}`}
                  className="text-sm text-mute transition-colors duration-200 hover:text-ink"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Company">
          <p className={colTitle}>Company</p>
          <ul className="mt-4 space-y-2.5">
            <li><Link to="/where-we-work" data-testid="footer-link-where-we-work" className="text-sm text-mute transition-colors duration-200 hover:text-ink">Where we work</Link></li>
            <li><Link to="/insights" data-testid="footer-link-insights" className="text-sm text-mute transition-colors duration-200 hover:text-ink">Insights</Link></li>
            <li><Link to="/#about" data-testid="footer-link-about" className="text-sm text-mute transition-colors duration-200 hover:text-ink">About</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="text-sm text-mute transition-colors duration-200 hover:text-ink">Contact</Link></li>
          </ul>
          <p className="mt-5 text-sm leading-relaxed text-mute">
            +971 50 571 4162
            <br />
            +91 74510 61965 · +91 98739 65559
          </p>
        </nav>
      </div>

      <div className="border-t border-line">
        <p data-testid="footer-copyright" className="mx-auto w-full max-w-[1200px] px-4 py-5 text-xs text-mute sm:px-6 lg:px-8">
          © 2026 Amplified Minds. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
